import { render, staticRenderFns } from "./TableDependencies.vue?vue&type=template&id=6839f7ce"
import script from "./TableDependencies.vue?vue&type=script&lang=js"
export * from "./TableDependencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports